import { Trans } from '@lingui/react/macro';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@repo/videa-components/src/index';

import type { ZuubWaitingPeriod } from '@/@types/zuub/contracts';
import { useLocalizedFormatDate } from '@/modules/claims/freeClaims/state';

interface WaitingPeriodsTableProps {
  data: ZuubWaitingPeriod[];
}

export const WaitingPeriodsTable = ({ data }: WaitingPeriodsTableProps) => {
  const formatDate = useLocalizedFormatDate();

  if (data.length === 0) {
    return (
      <div className="vai-text-center vai-text-gray-500 vai-py-8">
        <Trans>No waiting periods data available.</Trans>
      </div>
    );
  }

  return (
    <div className="vai-w-full vai-overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="vai-text-left vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>Service Type</Trans>
            </TableHead>
            <TableHead className="vai-text-center vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>Start Date</Trans>
            </TableHead>
            <TableHead className="vai-text-center vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>End Date</Trans>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={`${item.serviceType}-${index}`}>
              <TableCell className="vai-text-sm vai-text-foreground">
                {item.serviceType}
              </TableCell>
              <TableCell className="vai-text-sm vai-text-foreground vai-text-center">
                {formatDate(item.startDate)}
              </TableCell>
              <TableCell className="vai-text-sm vai-text-foreground vai-text-center">
                {formatDate(item.endDate)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
